import { render, staticRenderFns } from "./FourthSection.vue?vue&type=template&id=5d00df53&scoped=true&"
import script from "./FourthSection.vue?vue&type=script&lang=js&"
export * from "./FourthSection.vue?vue&type=script&lang=js&"
import style0 from "./FourthSection.vue?vue&type=style&index=0&id=5d00df53&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d00df53",
  null
  
)

export default component.exports